import { createReducer, on } from '@ngrx/store';
import { ProductVariantsActions } from 'src/app/core/state/app.actions';
import { STATE_STATUS } from 'src/app/shared/models';
import { ProductVariantsState } from './product-variants.state';

export const TAG = 'productVariants';

export interface FiltersType {
	structureUUID?: string;
	featureValue?: string[];
	communityUUID?: string;
	active?: boolean;
	updateDate?: string;
	communityEntityUUID?: string;
	[key: string]: unknown;
}

const initialState: ProductVariantsState = {
	filters: {
		featureValue: [],
		active: undefined,
	},
	sort: undefined,
	pages: [0],
	data: { totalProductsCount: 0, products: [] },
	features: [],
	structures: [],
	status: STATE_STATUS.UNKNOWN,
	gridSearch: null,
	deleteStatus: 'unknown',
	cachedPages: [],
};

export const counterReducer = createReducer(
	initialState,
	/**
	 * Parte standard di un reducer
	 */
	on(ProductVariantsActions.setSort, (state: ProductVariantsState, { sort }) => ({
		...state,
		sort,
	})),
	on(ProductVariantsActions.setPages, (state: ProductVariantsState, { pages }) => ({
		...state,
		pages,
	})),
	on(ProductVariantsActions.setProductsSuccess, (state: ProductVariantsState, { data }) => {
		return {
			...state,
			status: STATE_STATUS.READY,
			data: {
				products: [...state.data.products, ...data.products].filter((product) => product),
				totalProductsCount: data.totalProductsCount,
			},
			pages: [...state.cachedPages, ...data.pages],
		};
	}),
	on(ProductVariantsActions.setProductsError, (state: ProductVariantsState) => ({
		...state,
		status: STATE_STATUS.ERROR,
	})),
	on(ProductVariantsActions.setStatus, (state: ProductVariantsState, { status }) => {
		return {
			...state,
			status,
		};
	}),
	on(ProductVariantsActions.setGridSearch, (state: ProductVariantsState, { search }) => {
		return {
			...state,
			gridSearch: search,
		};
	}),
	on(ProductVariantsActions.setDeleteProducts, (state: ProductVariantsState) => {
		return {
			...state,
			deleteStatus: STATE_STATUS.LOADING,
		};
	}),
	on(ProductVariantsActions.setDeleteProductsSuccess, (state: ProductVariantsState) => {
		return {
			...state,
			deleteStatus: STATE_STATUS.READY,
		};
	}),
	on(ProductVariantsActions.setDeleteProductsError, (state: ProductVariantsState) => {
		return {
			...state,
			deleteStatus: STATE_STATUS.ERROR,
		};
	}),
	/**
	 * PARTE SPECIFICA DEL REDUCER
	 */
	on(ProductVariantsActions.setFilters, (state: ProductVariantsState, { filters }) => ({
		...state,
		filters: {
			...filters,
			structureUUID: filters.structureUUID !== 'allStructures' ? filters.structureUUID : undefined,
			communityUUID: filters.communityEntityUUID,
		},
	})),
	on(ProductVariantsActions.setStructures, (state: ProductVariantsState, { structures }) => ({
		...state,
		structures,
	})),
	on(ProductVariantsActions.setFeatures, (state: ProductVariantsState, { features }) => ({
		...state,
		features,
	})),
	on(ProductVariantsActions.updateFilters, (state: ProductVariantsState, { updatedFilters }) => ({
		...state,
		filters: {
			...state.filters,
			...updatedFilters,
		},
	})),
	on(ProductVariantsActions.addFeatureValueToFilters, (state: ProductVariantsState, { featureValueUUID }) => ({
		...state,
		filters: {
			...state.filters,
			featureValue: state.filters.featureValue?.concat(featureValueUUID),
		},
	})),
	on(ProductVariantsActions.removeFeatureValueFromFilters, (state: ProductVariantsState, { featureValueUUID }) => ({
		...state,
		filters: {
			...state.filters,
			featureValue: state.filters.featureValue?.filter((uuid) => uuid !== featureValueUUID),
		},
	})),
	on(ProductVariantsActions.setCachedPages, (state: ProductVariantsState, { pages }) => ({
		...state,
		cachedPages: [...new Set([...state.cachedPages, ...pages])],
	})),
	on(ProductVariantsActions.resetCache, (state: ProductVariantsState) => ({
		...state,
		cachedPages: [],
		pages: [0],
		data: { totalProductsCount: 0, products: [] },
	}))
);
